<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { formatHumanDate } from '../../../utils/CommonFunctions';

defineProps<{
  record?: any,
}>()

// Sample data for customer history
interface Event {
  name: string;
  routePath: string;
  createdAt: string;
  user: string;
}

const data = ref<Event[]>([])

onMounted(async () => {
    //data.value = await firebaseService.getUserEvents(props.record?.uid)
})
</script>

<template>
  <div
    v-for="(event, index) in data"
    :key="index"
    class="p-4 bg-gray-50 dark:bg-gray-900 rounded-lg"
    >
    <div class="flex items-start gap-3">
        <span class="text-2xl">✏️</span>
        <div>
        <p class="font-medium text-gray-900 dark:text-white">{{ event.name }}</p>
        <p class="text-sm text-gray-600 dark:text-gray-400">{{ event.routePath }}</p>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ formatHumanDate(event.createdAt) }} by {{ event.user }}</p>
        </div>
    </div>
    </div>

</template>